<template>
  <Paywall class="residential-account-settings" :value="$path('reference.status', item)" :items="['sold', 'rented']">
    <template #default>
      <Card class="residential-account-settings__content">
        <template #header>
          <h2>{{ $t('settings') }}</h2>
        </template>
        <template #default>
          <InputComponent
            :label="$tc('owner', 2)"
            @click.native="$router.push({ name: 'residential-edit', params: { id: item.reference.id, step: 'basis' } })"
          >
            <ContactSelect v-model="value.owners" multiple readonly :items="[]" class="elder-input__element" />
            <template #below>
              <DeliveryLog v-if="deliveryLog" class="mt-1" :resource="$t('residentialAccount')" :value="deliveryLog" />
            </template>
          </InputComponent>

          <CheckboxComponent
            v-model="value.metadata.settings.showShop"
            :label="$t('residentialAccountSettingsShowShop')"
            :sublabel="$t('residentialAccountSettingsShowShopSublabel')"
            theme="toggle"
            class="mt-2"
          />
          <CheckboxComponent
            v-model="value.metadata.settings.showShopDocuments"
            :label="$t('residentialAccountSettingsShowShopDocuments')"
            :sublabel="$t('residentialAccountSettingsShowShopDocumentsSublabel')"
            theme="toggle"
          />
          <CheckboxComponent
            v-model="value.metadata.settings.showResidentialDocuments"
            :label="$t('residentialAccountSettingsShowResidentialDocuments')"
            :sublabel="$t('residentialAccountSettingsShowResidentialDocumentsSublabel')"
            theme="toggle"
          />
          <Address v-if="item.reference" :id="$path('reference.id', item)" @close="showAddress = false" />
        </template>
        <template #footer>
          <ButtonComponent
            v-if="!hasAddress"
            class="residential-account-settings__content-address-trigger residential-account-settings__content-address-trigger--error"
            @click="Bus.$emit('show:address:control')"
            :label="$t('residentialAddressControl')"
            :icon="['fas', 'exclamation-triangle']"
          />
        </template>
      </Card>
    </template>
    <template #content>
      <Alert theme="warning" style="max-width: 500px">
        <div>{{ $t('residentialAccountNotSold') }}</div>
        <ButtonComponent
          class="mt-1"
          tag="router-link"
          :label="`${$t('edit')} ${$tc('unit', 1).toLowerCase()}`"
          :icon="['fal', 'pen']"
          :to="{ name: 'residential-edit', params: { id: $path('reference.id', item), step: 'basis' } }"
        />
      </Alert>
    </template>
  </Paywall>
</template>

<script>
import { mapState } from 'vuex'
import Bus from '@/bus'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { Paywall } from '@/components/Upsell'
import ContactSelect from '@/components/Contact/Select/Modal'
import DeliveryLog from '@/components/DeliveryLog'
import Address from './Address'

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      showAddress: true,
      Bus: Bus,
    }
  },
  computed: {
    ...mapState('ResidentialAccount', ['item']),
    hasAddress() {
      if (!this.showAddress) return true
      return ['city', 'postcode', 'county', 'street'].every(k => this.$path('reference.address.' + k, this.item))
    },
    deliveryLog() {
      if (!this.item.deliveryLogs) return
      return this.item.deliveryLogs.filter(d => new RegExp(`^residential-account:.+:invite:.+$`).test(d.tag)).pop()
    },
  },
  components: {
    Card,
    CheckboxComponent,
    InputComponent,
    Alert,
    Paywall,
    ContactSelect,
    DeliveryLog,
    Address,
  },
}
</script>

<style lang="scss">
.residential-account-settings {
  &__content {
    &-address-trigger {
      margin-left: auto;

      &--success svg {
        color: var(--success);
      }

      &--error svg {
        color: var(--error);
      }
    }

    .card {
      &__content {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        flex-grow: 0;
      }

      &__header {
        min-height: initial;
        flex-direction: row;
        justify-content: flex-start;

        h2 {
          margin: 0;
        }
      }
    }
  }
}
</style>
